import { Button, Image, Typography } from '@smartgift/frontend-toolkit';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useTheme } from 'styled-components';

import { RECOGNITIONS_TAB } from '@hero/constants';
import { shareLinks } from '@hero/data';
import { ROUTE_PATHS } from '@hero/routes';

import * as S from './style';

function ShareAnywhere({ secureSingleLink, recognitionCode }) {
  const theme = useTheme();
  const orderConfirmedImage = theme?.images?.orderConfirmed;
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <S.ShareAnywhere>
      <S.ShareAnywhereImage>
        <Image src={orderConfirmedImage} alt="order confirmed" width="100%" height={145} />
        <Typography variant="body1Bold">{t('thanksForYourOrder')}</Typography>
        <Typography
          variant="body2"
          color="neutral"
          emphasis="500"
          as="div"
          style={{ display: 'ruby', width: '340px', margin: 'auto' }}
        >
          <Trans
            i18nKey="thanksForYourOrderDesc"
            components={{
              a1: (
                <Button
                  variant="link"
                  onClick={() => {
                    navigate(ROUTE_PATHS.MY_RECOGNITION_DETAIL(recognitionCode));
                  }}
                />
              ),
              a2: (
                <Button
                  variant="link"
                  onClick={() => {
                    navigate(
                      `${ROUTE_PATHS.MY_RECOGNITION_DETAIL(recognitionCode)}#${
                        RECOGNITIONS_TAB.analytics
                      }`
                    );
                  }}
                />
              )
            }}
          />
        </Typography>
      </S.ShareAnywhereImage>
      <S.ShareAnywhereLinks>
        {shareLinks.map(({ name, label, logo, share }, index) => (
          <S.ShareAnywhereLink
            key={index}
            href={share(secureSingleLink)}
            target="_blank"
            rel="noreferrer"
          >
            <Image src={logo} alt={name} width={28} height={28} />
            <S.ShareAnywhereText variant="caption2Bold">{label}</S.ShareAnywhereText>
          </S.ShareAnywhereLink>
        ))}
      </S.ShareAnywhereLinks>
    </S.ShareAnywhere>
  );
}

export { ShareAnywhere };
